import React from "react";
import PropTypes from "prop-types";
import { ModalDialog, Button } from "../odc-ui";
import { CloseIcon } from "./uikit";
import { Frame } from "@bitesite/react-figstrap";
import numeral from "numeral";

function TopUpTableModal({
  onClose,
  currentTopUpCampaign,
  showAddFundsButton,
}) {
  function handleCloseClick(e) {
    e.preventDefault();
    if (onClose) {
      onClose(e);
    }
  }

  return (
    <ModalDialog
      modalDialogClassName="component-top-up-table-modal"
      maxWidth={700}
      darkMode={false}
      marginTop={100}
    >
      <Frame vertical padding={20} gap={20}>
        <Frame justifyContent="space-between">
          <Frame justifyContent="end" className="modal-info regular-bold">
            Top-Up Event
          </Frame>
          <a className="close-button-link" onClick={handleCloseClick}>
            <CloseIcon className="close-button" />
          </a>
        </Frame>

        <Frame justifyContent="end" className="modal-info">
          From now until {currentTopUpCampaign.english_friendly_end_date},
          invest funds into your account and receive an immediate top-up deposit
          as part of {currentTopUpCampaign.name}!
        </Frame>
        <Frame
          justifyContent="space-between"
          className="top-up-table-container"
        >
          <table className="standard-table light top-up-table">
            <thead>
              <tr>
                <th>Invest these funds</th>
                <th>Category</th>
                <th>To receive these Top - Ups</th>
              </tr>
            </thead>
            <tbody>
              {currentTopUpCampaign &&
                currentTopUpCampaign.top_up_campaign_items &&
                currentTopUpCampaign.top_up_campaign_items.map((item) => {
                  const { product } = item;

                  if (
                    product.enabled_for_dermatology_prepaid ||
                    product.enabled_for_surgery_prepaid ||
                    product.enabled_for_dermatology_auto_grow ||
                    product.enabled_for_surgery_auto_grow
                  ) {
                    return (
                      <tr key={item.id}>
                        <td>{numeral(product.price).format("$0,0.00")}</td>
                        <td>
                          {product.enabled_for_dermatology_prepaid &&
                            "Dermatology Prepaid"}
                          {product.enabled_for_surgery_prepaid &&
                            "Surgery Prepaid"}
                          {product.enabled_for_dermatology_auto_grow &&
                            "Dermatology Auto Grow"}
                          {product.enabled_for_surgery_auto_grow &&
                            "Surgery Auto Grow"}
                        </td>
                        <td>
                          {numeral(item.amount_in_hundredths / 100).format(
                            "$0,0.00"
                          )}
                        </td>
                      </tr>
                    );
                  } else {
                    return null;
                  }
                })}
            </tbody>
          </table>
        </Frame>
        {window.gon && window.gon.current_user && showAddFundsButton && (
          <Button type="dark" href="/add_funds">
            Add Funds & Get Top-Ups
          </Button>
        )}
      </Frame>
    </ModalDialog>
  );
}

TopUpTableModal.propTypes = {
  currentTopUpCampaign: {},
  showAddFundsButton: false,
};

TopUpTableModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  currentTopUpCampaign: PropTypes.object,
  showAddFundsButton: PropTypes.object,
};

export default TopUpTableModal;
